module.exports = __webpack_public_path__ + "static/media/1.00524b96.png";